<template>
  <div
    ref="crumbItem"
    class="link-crumb-item item-list"
    :class="{'hover-active': isShowDropdown}"
    @click="openList"
  >
    <!-- 这里的标签一定要是span标签，方便计算长度 -->
    <span
      ref="sepreator"
      class="sepreator"
    >&nbsp;/&nbsp;</span>
    <span
      ref="pathName"
      class="path-name"
    >
      <svg class="ellipsis">
        <use xlink:href="#dian" />
      </svg>
    </span>
    <dropdown
      :is-show-dropdown="isShowDropdown"
      :parent-node="clickNode"
      :dropdown-styles="{}"
      @close="closeList"
    >
      <div
        v-for="(item, index) in listData"
        :key="index"
        class="crumb-list-item"
        :index="(+index + 1)"
        :title="getCurrentPath(item)"
      >
        {{ getCurrentPath(item) }}
      </div>
    </dropdown>
  </div>
</template>

<script>
import dropdown from 'components/business/link/dropdown/dropdown.vue'

export default {
  name: 'CrumbItem',
  components: {
    dropdown,
  },
  props: {
    listData: Array,
  },
  data() {
    return {
      originWidth: 0,
      isShowDropdown: false,
      clickNode: null,
    }
  },
  computed: {

  },
  mounted() {
    this.$nextTick(() => {
      this.originWidth = this.$refs.pathName.offsetWidth
      if (this.$refs.sepreator) {
        this.originWidth += this.$refs.sepreator.offsetWidth
      }
      this.clickNode = this.$el
    })
  },
  methods: {
    // 获取当前路径名
    getCurrentPath(itemData) {
      const idx = itemData.path.lastIndexOf('/')
      if (idx <= 0) {
        return itemData.path.substring(1)
      }
      return itemData.path.substring(idx + 1)
    },
    openList(e) {
      this.isShowDropdown = true
    },
    closeList(e) {
      this.isShowDropdown = false
    },
  },
}
</script>

<style lang="less">

</style>
